<template>
    <Panel :modal="modal" title="Priser" :action="isAdmin ? 'Opret pris' : null" @click="onAddPrice">
        <table class="table is-fullwidth">
            <tbody v-if="item.prices.length>0">
                <tr>
                    <td><u>Type</u></td>
                    <td><u>Levering</u></td>
                    <td><u>Tilstand</u></td>
                    <td><u>Pris</u></td>
                    <td v-if="item.type.key === 'no_serial'"><u>Tomt lager</u></td>
                    <td></td>
                </tr>
                <tr v-for="price in item.prices" :key="price.id">
                    <td :class="{ 'is-outdated': price.is_outdated }">
                        <span :class="['icon mr-0', price.manufacturer_price_type.delivery_type.in_stock ? 'has-text-success' : 'has-text-danger']" :title="price.manufacturer_price_type.delivery_type.in_stock ? 'På lager' : 'Ikke på lager'">
                            <i class="fas fa-truck"/>
                        </span>

                        {{ price.type.name }}
                        <strong v-if="price.type.require_return_item">*</strong>
                    </td>
                    <td>
                        {{ price.manufacturer_price_type.delivery_type.name}}
                    </td>
                    <td>
                        {{ price.manufacturer_price_type.price_type.condition.name }}
                    </td>
                    <td>
                        <div v-if="selectedPriceId !== price.id" :class="{'pointer': isAdmin}">
                            <p @click.prevent="edit(price)" :class="{ 'is-outdated': price.is_outdated }">
                                {{ price.price_display }}
                                <span class="price-eur" v-if="settingByKey('inventory.exchange.rate')">
                                    {{ getEURPrice(price.price) }} EUR
                                </span>
                            </p>
                            <span v-if="price.is_outdated" class="is-outdated date">
                                (Sidst opdateret d. {{ price.updated_at }})
                            </span>
                        </div>
                        <div v-else>
                            <InputText :ref="'price-' + price.id"
                                    :value="getFormattedPrice(price.price)"
                                    type="number"
                                    @blur="update(price,$event)"
                                    @keyup.enter="onUpdateKeyUpEnter"/>
                        </div>
                    </td>
                    <td v-if="item.type.key === 'no_serial'" class="has-text-centered">
                        <b-switch
                            :rounded="false"
                            @input="toggleOutOfStockSales(price)"
                            v-model="price.out_of_stock_sales"
                            class="users-change__toggle"
                        >
                            {{ price.out_of_stock_sales ? '' : '' }}
                        </b-switch>
                    </td>
                    <td class="has-text-right">
                        <a v-if="isAdmin && price.is_outdated" class="button is-small" title="Bekræft" @click.prevent="confirmPrice(price)">
                            <span class="icon is-green"><i class="fas fa-check"/></span>
                        </a>
                        <a class="button is-small ml-auto" title="Historik" @click.prevent="showHistory(price)">
                            <span class="icon"><i class="fas fa-history"/></span>
                        </a>
                        <a v-if="isAdmin" class="button is-small" title="Slet" @click.prevent="remove(price)">
                            <span class="icon"><i class="fas fa-trash-alt"/></span>
                        </a>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td colspan="3">Ingen priser oprettet</td>
                </tr>
            </tbody>
        </table>
        <div class="details" v-if="hasPriceTypeWithRequiredReturnItem">
        * Kræver returvare
        </div>

        <PriceModal :active="showPriceModal"
                        :item="item"
                        @closed="onClosePriceModal"
                        @created="onCreated"/>

        <PriceHistoryModal
            :active="showPriceHistoryModal"
            :price="selectedPrice"
            @closed="onCloseHistoryModal"
        />
    </Panel>
</template>

<script>
import Panel from "@elems/Panel";
import PriceModal from "./forms/PriceModal";
import PriceHistoryModal from "./show/PriceHistoryModal";
import humanDate from "../../filters/humanDate";
import {InputText} from '@elems/form'
import {mapActions,mapGetters} from "vuex";

export default {
    components: { InputText, PriceModal, PriceHistoryModal, Panel },
    filters: {
        humanDate,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        isAdmin: {
            type: Boolean,
            required: true,
        },
        showAdminFields: {
            type: Boolean,
            required: true,
        },
        modal: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters([
            'settingByKey'
        ]),
        hasPriceTypeWithRequiredReturnItem() {
            return this.item.prices.some(price => price.type.require_return_item === true);
        },
    },
    data() {
        return {
            showPriceModal: false,
            showPriceHistoryModal: false,
            selectedPriceId: null,
            selectedPrice: null,
            apiUrl: '/api/prices',
        };
    },
    methods: {
        ...mapActions([
            'loadSettings'
        ]),
        getEURPrice(price) {
            console.log('f', this.settingByKey('inventory.exchange.rate'))
            const EUR = this.settingByKey('inventory.exchange.rate').value / 100;
            let pr = price / 100;
            return Math.round((pr / 100) * (100 / EUR));
        },
        confirmPrice(price) {
            if (!confirm('Er du sikker på at du vil bekræfte prisen?')) {
                return
            }

            window.axios.post('/api/prices/' + price.id + '/confirm')
                .then((response) => {
                    this.$emit('updated');
                })
                .catch(error => {
                    console.error(error)
                });
        },
        toggleOutOfStockSales(price) {
            window.axios.put(`${this.apiUrl}/${price.id}`, { out_of_stock_sales: price.out_of_stock_sales })
                .then(() => {
                    if (price.out_of_stock_sales)
                        this.$store.dispatch('setSuccess', 'Prisentypen er nu salgbar når lageret er tomt')
                    else
                        this.$store.dispatch('setSuccess', 'Prisentypen er ikke længere salgbar når lageret er tomt')

                })
                .catch(error => {
                    this.$store.dispatch('setError', 'Prisen kunne ikke opdateres')
                    console.error(error)
                });
        },
        getFormattedPrice(value) {
            return (value / 100).toFixed(2);
        },
        edit(price) {
            if (!this.isAdmin)
                return;

            this.selectedPriceId = price.id;
            this.$nextTick(() => {
                const inputs = this.$refs['price-' + price.id];
                if (inputs.length) {
                    inputs[0].$el.focus();
                }
            })
        },
        onAddPrice() {
            this.showPriceModal = true;
        },
        onClosePriceModal() {
            this.showPriceModal = false;
        },
        onCreated(data) {
            this.$emit('updated', data);
        },
        showHistory(price) {
            this.selectedPrice = price;
            this.showPriceHistoryModal = true;
        },
        onCloseHistoryModal() {
            this.showPriceHistoryModal = false;
        },
        remove(price) {
            if (!confirm('Er du sikker på du vil slette ' + price.type.name + '?')) {
                return
            }

            window.axios.delete(`${this.apiUrl}/${price.id}`)
                .then(() => {
                    this.$store.dispatch('setSuccess', 'Prisen blev slettet')
                    this.$emit('updated');
                })
                .catch(error => {
                    this.$store.dispatch('setError', 'Prisen kunne ikke slettes')
                    console.error(error)
                });
        },
        update(price, value) {
            if (value && price.price!==parseInt(value*100)) {
                window.axios.put(`${this.apiUrl}/${price.id}`, { price: value })
                .then(() => {
                    this.$emit('updated');
                })
                .catch(error => {
                    this.$store.dispatch('setError', 'Prisen kunne ikke opdateres')
                    console.error(error)
                });
            }
            this.selectedPriceId = null;
        },
        onUpdateKeyUpEnter() {
            this.selectedPriceId = null;
        }
    },
    created() {
        this.loadSettings();
    }
}
</script>

<style lang="scss" scoped>
@import '~#/globals';

.price-eur {
    font-size: 12px;
    display: block;
}

.details {
    margin-top: 0.5rem;
    font-size: 13px;
    font-style: italic;
}
.pointer {
    cursor: pointer;
}
table tbody tr td:first-child {
    width: 33% !important;
}
table tbody tr td:not(first-child) {
    width: auto !important;
}
.ml-auto {
    margin-left: auto;
}
</style>
